// Dependency imports
import React, { useState, useRef, useEffect } from 'react';
import { CircleUserRound } from 'lucide-react';

// Local imports
import ThirdEye from '../../assets/images/logo.svg';
import { useAppSelector } from 'hooks';
import AccountPaper from './AccountPaper';

interface IAppbarProps {
  onMenuClick?: () => void;
}

const Appbar: React.FC<IAppbarProps> = ({ onMenuClick }) => {
  const [isAccountPaperOpen, setIsAccountPaperOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);
  const { profile } = useAppSelector(state => state.auth);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        !isModalOpen &&
        popoverRef.current &&
        buttonRef.current &&
        !popoverRef.current.contains(event.target as Node)
        // !buttonRef.current.contains(event.target as Node)
      ) {
        setIsAccountPaperOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isModalOpen]);

  const handleModalOpen = (isOpen: boolean) => {
    setIsModalOpen(isOpen);
  };

  return (
    <div className="bg-[#102533] w-full z-10 shadow-md h-[8vh] flex items-center justify-between">
      <div className="flex items-center justify-between w-[96%] mx-[2%] h-full">
        <div className="flex flex-1 items-center justify-center ml-[20%]">
          <img src={ThirdEye} className="w-[20vw]" alt="ThirdEye Logo" />
        </div>
        <div
          ref={buttonRef}
          className="flex flex-[0.3] items-center text-white justify-end gap-1 cursor-pointer"
          onClick={() => setIsAccountPaperOpen(!isAccountPaperOpen)}
        >
          <p className="text-[1vw]">Welcome, {profile?.name}</p>
          <CircleUserRound className="w-[2vw] h-auto" />
        </div>
      </div>

      {isAccountPaperOpen && (
        <div
          ref={popoverRef}
          className="absolute right-4 top-[8vh] bg-white rounded-md shadow-lg transform transition-all duration-200 ease-out  z-10000"
        >
          <div className="absolute -top-2 right-4 w-4 h-4 rotate-45 bg-white"></div>
          <div className="relative bg-white rounded-md">
            <AccountPaper onModalStateChange={handleModalOpen} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Appbar;
